import React, { useContext } from 'react';

const ImmutablesContext = React.createContext({});
const ImmutablesProvider = ImmutablesContext.Provider;
export const ImmutablesConsumer = ImmutablesContext.Consumer;

export const useMessages = (selector) => {
    const { messages } = useContext(ImmutablesContext);
    return selector ? selector(messages) : messages;
};

export const withMessages = (selector) => (Component) =>
    React.forwardRef((props, ref) => {
        const messageProp = useMessages(selector);

        return <Component {...props} messages={messageProp} ref={ref} />;
    });

export const useConfig = (selector) => {
    const { config } = useContext(ImmutablesContext);
    return selector ? selector(config) : config;
};

export const withConfig = (selector) => (Component) =>
    React.forwardRef((props, ref) => {
        const configProp = useConfig(selector);

        return <Component {...props} config={configProp} ref={ref} />;
    });

export const useAppState = (selector) => {
    const { appState } = useContext(ImmutablesContext);
    return selector ? selector(appState) : appState;
};

export const withAppState = (selector) => (Component) =>
    React.forwardRef((props, ref) => {
        const appStateProp = useAppState(selector);

        return <Component {...props} appState={appStateProp} ref={ref} />;
    });

export default ImmutablesProvider;
